import { Injectable } from '@angular/core';
import { DataUser, ObjLanguage } from '../inteface';
import {
  SYSTEM_TEXT,
  KEY_LANG,
  TICKETS_CONSTANT,
  POINT_CONFIG,
} from '../const/index';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class TicketsService {
  btnState = [
    {
      cl: 'danger',
      ico: '@tui.ticket-x',
      link: false,
      bage: false,
    },
    {
      cl: 'warning',
      ico: '@tui.ticket',
      link: true,
      bage: false,
    },
    {
      cl: 'secondary',
      ico: '@tui.ticket',
      link: true,
      bage: true,
    },
    {
      cl: 'success',
      ico: '@tui.ticket-check',
      link: true,
      bage: false,
    },
  ];

  constructor(private dataUser: UserService) {}

  j_in_array(value, array) {
    for (let i = 0; i < array.length; i++) {
      if (array[i] === value) return i;
    }
    return -1;
  }

  saveResult(arrRes, i) {
    // Получаем текущие данные пользователя
    const currentUser = this.dataUser.user;
    if (this.j_in_array(i, arrRes) === -1) {
      arrRes.push(i);
      currentUser.point += POINT_CONFIG.addPointTrueAns;
    }
    console.log('1');
    // Сохраняем обновленные данные через сеттер
    this.dataUser.user = currentUser;
  }

  buildTicketsList() {
    // Получаем текущие данные пользователя
    const currentUser = this.dataUser.user;
    const arrPrm = [];
    const aTick = TICKETS_CONSTANT;
    let count = 0;
    let indArr = 0;
    const resultArr = [[]];

    for (let i = 0; i < aTick.length; i++) {
      console.log(i, currentUser.questions, currentUser.isPro);
      const ticketStatus = this.j_in_array(i, currentUser.questions)
        ? currentUser.questions[i]
        : false;
      // console.log(ticketStatus);
      if (ticketStatus) {
        arrPrm.push({
          bage: this.btnState[0].bage,
          cl: this.btnState[ticketStatus.s].cl,
          numb: aTick[i].number,
          ico: this.btnState[ticketStatus.s].ico,
          link: ticketStatus.s,
        });
      } else {
        arrPrm.push({
          bage: this.btnState[0].bage,
          cl: this.btnState[0].cl,
          numb: aTick[i].number,
          ico: this.btnState[0].ico,
          link: 0,
        });
      }
    }

    function partition() {
      if (arrPrm.length > 0) {
        resultArr[indArr].push(arrPrm.shift());
        switch (count) {
          case 0:
            count = 1;
            break;
          case 1:
            count = 2;
            break;
          case 2:
            count = 0;
            indArr++;
            resultArr.push([]);
            break;
        }
        return partition();
      } else {
      }
    }
    partition();
    currentUser.synch = false;
    // Сохраняем обновленные данные через сеттер
    console.log(3);
    // this.dataUser.user = currentUser;
    return resultArr;
  }

  rebuildTicketsList() {
    return this.buildTicketsList();
  }
}
